import {
	Announcement,
	AnnouncementUserInteraction,
	AnnouncementsResponse,
	AnnouncementUserInteractionRequest,
	AnnouncementTemplateType,
	AnnouncementTemplate1
} from "@/Contracts/Announcement";
import { preloadImage } from "@/Utils/common";
import { getRequest, postRequest } from "@/Utils/Service/BackendService";
import axios, { AxiosResponse } from "axios";

const getAnnouncementUrl = "/v2/announcement?appName=grow";
const registerAnnouncementUserInteractionUrl =
	"/v2/announcement-user-interaction?appName=grow";

export const getAnnouncement = async (): Promise<Announcement | null> => {
	try {
		const response: AxiosResponse<AnnouncementsResponse> = await axios(
			getRequest(getAnnouncementUrl, null, true, true, false)
		);
		const announcement = response.data.data?.[0] ?? null;
		if (
			announcement?.template_type === AnnouncementTemplateType.Template1
		) {
			const template1 =
				announcement.template_metadata as AnnouncementTemplate1;
			if (template1.image_url) {
				await preloadImage(template1.image_url);
			}
		}
		return announcement;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const registerAnnouncementUserInteraction = async (
	announcementId: string,
	announcementUserInteraction: AnnouncementUserInteraction
) => {
	try {
		const response: AxiosResponse<void> = await axios(
			postRequest(
				registerAnnouncementUserInteractionUrl,
				new AnnouncementUserInteractionRequest(
					announcementId,
					announcementUserInteraction
				),
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
